var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDebitCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.996,
    height: 56.6,
    viewBox: "0 0 63.996 56.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16457",
    "data-name": "Group 16457",
    transform: "translate(-7232.796 12951.046)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8068",
    "data-name": "Rectangle 8068",
    width: 14,
    height: 5,
    rx: 2,
    transform: "translate(7245 -12915.645)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-dollar-currency-1538242",
    transform: "translate(7321.023 -12861.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16449",
    "data-name": "Group 16449",
    transform: "translate(-152 -81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24067",
    "data-name": "Path 24067",
    d: "M333.961,128.345a1.462,1.462,0,0,1-1.461-1.461v-2.923a1.461,1.461,0,0,1,2.923,0v2.923A1.462,1.462,0,0,1,333.961,128.345Z",
    transform: "translate(-222.497 -100.764)",
    stroke: "#000100",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24068",
    "data-name": "Path 24068",
    d: "M333.961,373.345a1.462,1.462,0,0,1-1.461-1.461v-2.923a1.461,1.461,0,0,1,2.923,0v2.923A1.462,1.462,0,0,1,333.961,373.345Z",
    transform: "translate(-222.497 -325.305)",
    stroke: "#000100",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24069",
    "data-name": "Path 24069",
    d: "M269.807,177.959a8.114,8.114,0,0,1-5.354-1.888,1.462,1.462,0,1,1,1.941-2.186,5.185,5.185,0,0,0,3.414,1.151c2.376,0,4.384-1.339,4.384-2.923s-2.008-2.923-4.384-2.923c-4.027,0-7.307-2.622-7.307-5.845s3.279-5.845,7.307-5.845a8.125,8.125,0,0,1,5.354,1.888,1.462,1.462,0,1,1-1.941,2.186,5.185,5.185,0,0,0-3.414-1.151c-2.376,0-4.384,1.339-4.384,2.923s2.008,2.923,4.384,2.923c4.03,0,7.307,2.622,7.307,5.845S273.837,177.959,269.807,177.959Z",
    transform: "translate(-158.342 -132.841)",
    stroke: "#000100",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24076",
    "data-name": "Path 24076",
    d: "M7427.994-12914.939c-.054-6.947,0-28.033,0-28.033s-.809-9.993-9.988-10-42.993-.076-42.993-.076-10.979.625-11,11.1,0,29.988,0,29.988-.038,9.983,10.067,9.97,15.961-.022,20.9,0,4.912-5.059,0-5.041-21.9,0-21.9,0a4.624,4.624,0,0,1-4.1-4.929c-.018-4.595,0-17.045,0-17.045h54s.057,10.2,0,14.061S7428.048-12907.992,7427.994-12914.939Z",
    transform: "translate(-131.202 2)",
    fill: "#000100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24079",
    "data-name": "Path 24079",
    d: "M7369.975-12939.5l52.192.027v-2.519s.5-5.269-4.085-5.388-44.035,0-44.035,0-4.523,0-4.584,5.388c-.011.932,0,1.615.036,2.422C7369.554-12939.567,7369.975-12939.5,7369.975-12939.5Z",
    transform: "translate(-131.027 2)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitCard);
export default __webpack_public_path__ + "static/media/debit_card.5195082cf0262c6601ca634ca8f33972.svg";
export { ForwardRef as ReactComponent };